export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'e6ce483', dateTime: 1770851706671 };